import { classNames } from 'lib/ClassNames';

const findStatus = (status, options, additional_text = '') => {
  const normalizedStatus = status?.toLowerCase().trim() || '';

  const foundType = options.find((x) => {
    const nameMatch = x.name?.toLowerCase().trim() === normalizedStatus;
    const valueMatch = x.value?.toLowerCase().trim() === normalizedStatus;
    return nameMatch || valueMatch;
  });

  return (
    <span className={classNames('inline-flex items-center text-sm font-normal capitalize')}>
      {foundType ? foundType.name : status?.toLowerCase().trim()}{' '}
      {foundType ? foundType.description : ''}
      {additional_text}
    </span>
  );
};

export { findStatus };
